// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3v-7m","list":"styles_list__OlvV0"};